import { Component, Input, OnInit } from '@angular/core';
import { CmsBannerComponent } from '@spartacus/core';
import { BannerComponent } from '@spartacus/storefront';
import { of, tap } from 'rxjs';

@Component({
  selector: 'cx-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  standalone: false,
})
export class CustomBannerComponent extends BannerComponent implements OnInit {
  @Input() item?: CmsBannerComponent;

  ngOnInit(): void {
    if (this.item) {
      this.data$ = of(this.item).pipe(
        tap(data => {
          this.setRouterLink(data);
          this.styleClasses = data.styleClasses;
        }),
      );
    }
  }
}
